import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { similarPositionsMock, restaurantImagesMock } from '@restworld/utils-common';

var restaurantPictures = _toConsumableArray(restaurantImagesMock);

var defaultImageArgs = {
  restaurantPictures: restaurantPictures
};

var similarPositions = _toConsumableArray(similarPositionsMock);

var defaultCardArgs = {
  items: _toConsumableArray(similarPositions)
};
export { defaultImageArgs, restaurantPictures, defaultCardArgs, similarPositions };